import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Field, TextInput, TextArea, Check } from "@/components/register/Fields";
import { PageHead } from "@/pages/admin/AdminLayout";

export default function Settings() {
  const [f, setF] = useState(null);
  useEffect(() => {
    api.get("/admin/settings").then((r) => setF(r.data));
  }, []);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = () => api.put("/admin/settings", {
    capacity: +f.capacity, closes_local: f.closes_local, show_remaining: f.show_remaining,
    price_dollars: +f.price_dollars, clothing_requirements: f.clothing_requirements, payment_link_url: (f.payment_link_url || "").trim(),
  }).then(() => toast.success("Settings saved")).catch((e) => toast.error(errMsg(e)));
  return (
    <div data-testid="admin-settings" className="max-w-2xl">
      <PageHead title="Camp settings" />
      <p className="text-sm text-slate-400 mb-8">{f.name} · {f.seats_taken} place(s) taken or held</p>
      <div className="space-y-5">
        <Field label="Capacity (players)"><TextInput testid="settings-capacity" type="number" value={f.capacity} onChange={set("capacity")} /></Field>
        <Field label={`Registration closes (${f.timezone} time)`}><TextInput testid="settings-closes" type="datetime-local" value={f.closes_local} onChange={set("closes_local")} /></Field>
        <Field label="Price per player (AUD incl. GST)" hint="Applies to new checkouts only."><TextInput testid="settings-price" type="number" step="0.01" value={f.price_dollars} onChange={set("price_dollars")} /></Field>
        <Field label="Stripe Payment Link (optional)" hint="Paste your https://buy.stripe.com/... link to take payments through it (one payment per player). Leave empty to use the built-in checkout. The link's price must match the price above."><TextInput testid="settings-payment-link" value={f.payment_link_url || ""} onChange={set("payment_link_url")} placeholder="https://buy.stripe.com/..." /></Field>
        <Field label="Clothing requirements (used in confirmation emails)"><TextArea testid="settings-clothing" rows={3} value={f.clothing_requirements} onChange={set("clothing_requirements")} /></Field>
        <Check testid="settings-show-remaining" checked={f.show_remaining} onChange={(v) => setF({ ...f, show_remaining: v })}>Show the public remaining-places counter</Check>
        <button data-testid="settings-save" onClick={save} className="btn-primary">Save settings</button>
      </div>
    </div>
  );
}
